import { Injectable, inject, signal } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { EquipmentWithWarrantiesGQL, EquipmentWithWarrantiesQuery ,
  EquipmentGQL,
  EquipmentOrderByInput,
  EquipmentQuery,
  EquipmentsPaginatedGQL,
  EquipmentsPaginatedQuery,
} from '@generated/sammathnaur.graphql'
import { firstValueFrom } from 'rxjs'
import { toSearchPageWhere } from '../../others/to-where-input'
import type { Apollo } from 'apollo-angular'

@Injectable({
  providedIn: 'root',
})
export class EquipmentsService {
  public readonly filterForm = new FormGroup({
    locationId_in: new FormControl([] as string[]),
    locationSectorId_in: new FormControl([] as string[]),
    locationEnvironmentId_in: new FormControl([] as string[]),
    archived: new FormControl(false as 'all' | false | true),
  })

  public orderBy = signal<EquipmentOrderByInput>(EquipmentOrderByInput.NameAsc)
  public limit = signal<number>(25)
  public offset = signal<number>(0)

  public readonly equipmentsQueryGQL = inject(EquipmentsPaginatedGQL)
  public readonly equipmentGQL = inject(EquipmentGQL)
  public readonly equipmentWithWarrantiesGql= inject(EquipmentWithWarrantiesGQL)

  public reset(): void {
    this.filterForm.reset()
    this.orderBy.set(EquipmentOrderByInput.NameAsc)
    this.limit.set(25)
    this.offset.set(0)
  }

  public async searchPage(): Promise<Apollo.QueryResult<EquipmentsPaginatedQuery>> {
    const observable$ = this.equipmentsQueryGQL.fetch({
      variables: {
        where: toSearchPageWhere(this.filterForm.getRawValue()),
        limit: this.limit(),
        offset: this.offset(),
        orderBy: this.orderBy(),
      },
    })

    return firstValueFrom(observable$)
  }

  public async searchOne(id: string): Promise<Apollo.QueryResult<EquipmentQuery>> {
    const observable$ = this.equipmentGQL.fetch({ variables: { id } })
    return firstValueFrom(observable$)
  }

  public async searchEquipmentWithWarranties(id: string): Promise<Apollo.QueryResult<EquipmentWithWarrantiesQuery>> {
    const observable$ = this.equipmentWithWarrantiesGql.fetch({ variables: { id } })
    return firstValueFrom(observable$)
  }
}
